import { useState } from "react";
import Team from "../../components/Team";

export default function About() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div>
      <div className="max-w-7xl mx-auto py-20 md:py-28 mt-24">
        <div className="flex flex-col md:flex-row items-center space-y-8 md:space-y-0 md:space-x-10">
          <div className="flex-1 space-y-5 md:space-y-10 p-2">
            <h1 className="text-3xl sm:text-3xl lg:text-3xl font-semibold leading-tight py-3">
              <span className="relative inline-block">
                Təlimatlara bax,
                <span className="absolute inset-x-0 bottom-0.5 h-1 bg-[#ffe8c2] z-[-1]"></span>
              </span>
              <br />
              <span className="text-black text-3xl">
                haqqımızda məlumat al!
              </span>
            </h1>
            <p className="text-gray-500">
              Peşəkarlarımızla daha yaxından tanış olmaq üçün təlimatlar
              bölməsindən videolarımızı izləyə bilərsiniz.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6">
              <button className="px-6 py-3 rounded-full bg-black text-white font-normal text-lg">
                Başlayaq
              </button>
              {/* <button className="px-6 py-3 rounded-full text-lg font-normal flex items-center space-x-2 bg-gray-100 hover:bg-gray-200">
                <PlayIcon className="w-4 h-4 text-gray-300" />
                <span>İzlə</span>
              </button> */}
            </div>
          </div>
          <div className="flex-1 flex justify-center items-center relative w-full">
            <Blob className="w-[150%] h-[150%] absolute top-[-20%] left-0 z-[-1] text-red-50 dark:text-[#ffe8c2]" />
            <div className="relative h-72 rounded-2xl shadow-2xl w-full overflow-hidden">
              <button
                aria-label="Play Button"
                className={`absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-transparent hover:bg-transparent ${
                  isHovered ? "text-white" : ""
                }`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <PlayIcon className="w-12 h-12" />
              </button>
              <img
                alt="Hero Image"
                className="object-cover w-full h-full"
                src="https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=800&q=80"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <Team /> */}
    </div>
  );
}

const PlayIcon = (props) => {
  return (
    <svg
      viewBox="0 0 58 58"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M28.9999 0.562988C13.3196 0.562988 0.562378 13.3202 0.562378 29.0005C0.562378 44.6808 13.3196 57.438 28.9999 57.438C44.6801 57.438 57.4374 44.6808 57.4374 29.0005C57.4374 13.3202 44.6801 0.562988 28.9999 0.562988ZM39.2223 30.272L23.5749 39.7247C23.3506 39.8591 23.0946 39.9314 22.8332 39.9342C22.5717 39.9369 22.3142 39.8701 22.0871 39.7406C21.86 39.611 21.6715 39.4234 21.5408 39.1969C21.4102 38.9705 21.3421 38.7133 21.3436 38.4519V19.5491C21.3421 19.2877 21.4102 19.0305 21.5408 18.8041C21.6715 18.5776 21.86 18.3899 22.0871 18.2604C22.3142 18.1308 22.5717 18.064 22.8332 18.0668C23.0946 18.0696 23.3506 18.1419 23.5749 18.2763L39.2223 27.729C39.4404 27.8619 39.6207 28.0486 39.7458 28.2713C39.8709 28.494 39.9366 28.7451 39.9366 29.0005C39.9366 29.2559 39.8709 29.507 39.7458 29.7297C39.6207 29.9523 39.4404 30.1391 39.2223 30.272Z" />
    </svg>
  );
};

const Blob = (props) => {
  return (
    <svg
      viewBox="0 0 578 440"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M239.184 439.443c-55.13-5.419-110.241-21.365-151.074-58.767C42.307 338.722-7.478 282.729.938 221.217c8.433-61.644 78.896-91.048 126.871-130.712 34.337-28.388 70.198-51.348 112.004-66.78C282.34 8.024 325.382-3.369 370.518.904c54.019 5.115 112.774 10.886 150.881 49.482 39.916 40.427 49.421 100.753 53.385 157.402 4.13 59.015 11.255 128.44-30.444 170.44-41.383 41.683-111.6 19.106-169.213 30.663-46.68 9.364-88.56 35.21-135.943 30.551z"
      />
    </svg>
  );
};
